import React from 'react';
import { connect } from 'react-redux';
import { Switch, Route } from 'react-router-dom';
import StandardPageTemplate from '../../common/components/Layout/StandardPageTemplate';
import { LogoutMenuItem } from '../../common/components/Layout/Header/MenuConfig';
import PageNotFound from '../../common/components/NotFound/PageNotFound';
import { getCurrentUser } from '../../redux-modules/current-user';
import Catalog from './Views/Catalog';
import Detail from './Views/Detail';

const Entry = ({ match: { path }, menuItems }) => {
  return (
    <StandardPageTemplate
      defaultDocTitle="Events | NFIB"
      menuItems={menuItems}
    >
      <Switch>
        <Route
          path={`${path}/:eventId([0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12})`}
          component={Detail}
        />
        <Route exact path={`${path}/`} component={Catalog} />
        <Route component={PageNotFound} />
      </Switch>
    </StandardPageTemplate>
  );
};

const mapStateToProps = state => {
  const currentUser = getCurrentUser(state);
  return {
    menuItems: currentUser && currentUser.id ? [LogoutMenuItem] : [],
  };
};

export default connect(mapStateToProps)(Entry);



// WEBPACK FOOTER //
// ./src/App/events/index.js